module.exports = __webpack_public_path__ + "static/cta-banner-f4e41564aad891bea19c6ac38b076614.jpg";